module.exports = __webpack_public_path__ + "static/media/additives.4481fb35.png";